module.exports = __webpack_public_path__ + "7d088296/img/google.68f3823e.svg";